module.exports = __webpack_public_path__ + "img/weibo.2e9e947c.png";